<template>
  <b-modal 
    ref="modalDesossaAbate" 
    id="modal-configuracao-desossa-abate" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="xl"
    @shown="onModalShown"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #e91e63 0%, #c2185b 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-industry text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configurações de Desossa / Abate</h5>
        <small class="text-white opacity-75">Defina os parâmetros de desossa, abate e pesagens</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Corpo do Modal -->
    <div class="p-4" style="max-height: 70vh; overflow-y: auto;">
      
      <!-- Grupo Desossa / Abate -->
      <div class="modal-section-title mb-3">
        <i class="fa fa-cut mr-2 text-danger"></i> Desossa / Abate
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Cliente Desossa" label-for="cod-cli-desossa">
            <cliente-pesquisa 
              @retornaId="registro.COD_CLI_DESOSSA = $event"
              :idInicial="registro.COD_CLI_DESOSSA"
              label=""
              place="Digite o Nome ou Código do Cliente"
              labelBotao=""
              ref="clientePesquisa"
              idModal="modalClienteDesossa">
            </cliente-pesquisa>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Produto Peso das Bandas Abate" label-for="cd-produto-banda">
            <produto-pesquisa
              @retornaId="registro.CD_PRODUTO_BANDA_ABATE = $event"
              :idInicial="registro.CD_PRODUTO_BANDA_ABATE"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoBandaPesquisa"
              idModal="modalProdutoBanda">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Centro de Custo" label-for="id-centro-custo-desossa">
            <centro-custo-drop-down 
              v-model="registro.ID_CENTRO_CUSTO_DESOSSA"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Conferente" label-for="id-conferente-desossa">
            <funcionario-dropdown 
              v-model="registro.ID_CONFERENTE_DESOSSA"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Custo Operacional" label-for="custo-op-abate">
            <custo-operacional-drop-down 
              v-model="registro.CUSTO_OP_ABATE_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Embalagem Padrão Desossa" label-for="embalagem-desossa">
            <bens-pesquisa
              @retornaId="registro.EMBALAGEM_DESOSSA_ID = $event"
              :idInicial="registro.EMBALAGEM_DESOSSA_ID"
              label=""
              place="Digite o Nome ou Código da Embalagem"
              labelBotao=""
              ref="bensPesquisa"
              idModal="modalBensDesossa">
            </bens-pesquisa>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_USAR_CLIENTE_UNICO_DESOSSA"
            value="1"
            unchecked-value="0"
          >
            Usar esse cliente para todos os estudos de lucro
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_EXIBIR_QUALIDADE_ABATE"
            value="1"
            unchecked-value="0"
          >
            Ocultar Qualidade no Romaneio
          </b-form-checkbox>
        </b-col>
      </b-row>

      <!-- Grupo IDs do Abate -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-tags mr-2 text-warning"></i> IDs do Abate
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Boi ID" label-for="boi-id">
            <produto-pesquisa
              @retornaId="registro.BOI_ID = $event"
              :idInicial="registro.BOI_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoBoiPesquisa"
              idModal="modalProdutoBoi">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Vaca ID" label-for="vaca-id">
            <produto-pesquisa
              @retornaId="registro.VACA_ID = $event"
              :idInicial="registro.VACA_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoVacaPesquisa"
              idModal="modalProdutoVaca">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Novilho ID" label-for="novilho-id">
            <produto-pesquisa
              @retornaId="registro.NOVILHO_ID = $event"
              :idInicial="registro.NOVILHO_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoNovilhoPesquisa"
              idModal="modalProdutoNovilho">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Touro ID" label-for="touro-id">
            <produto-pesquisa
              @retornaId="registro.TOURO_ID = $event"
              :idInicial="registro.TOURO_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoTouroPesquisa"
              idModal="modalProdutoTouro">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Búfalo Macho ID" label-for="bufalo-macho-id">
            <produto-pesquisa
              @retornaId="registro.BUFALO_MACHO_ID = $event"
              :idInicial="registro.BUFALO_MACHO_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoBufaloMachoPesquisa"
              idModal="modalProdutoBufaloMacho">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Búfalo Fêmea ID" label-for="bufalo-femea-id">
            <produto-pesquisa
              @retornaId="registro.BUFALO_FEMEA_ID = $event"
              :idInicial="registro.BUFALO_FEMEA_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoBufaloFemeaPesquisa"
              idModal="modalProdutoBufaloFemea">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Boi Inteiro ID" label-for="boi-inteiro-id">
            <produto-pesquisa
              @retornaId="registro.BOI_INTEIRO_ID = $event"
              :idInicial="registro.BOI_INTEIRO_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoBoiInteiroPesquisa"
              idModal="modalProdutoBoiInteiro">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Boi Capão ID" label-for="boi-capao-id">
            <produto-pesquisa
              @retornaId="registro.BOI_CAPAO_ID = $event"
              :idInicial="registro.BOI_CAPAO_ID"
              label=""
              place="Digite o Nome ou Código do Produto"
              labelBotao=""
              ref="produtoBoiCapaoPesquisa"
              idModal="modalProdutoBoiCapao">
            </produto-pesquisa>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Taras e Pesagens -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-balance-scale mr-2 text-info"></i> Taras e Pesagens
      </div>
      <b-row>
        <b-col md="4">
          <b-form-group label="Tara Trilho Abate" label-for="tara-abate">
            <vue-autonumeric
              v-model="registro.TARA_ABATE"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tara Trilho Expedição" label-for="tara-expedicao">
            <vue-autonumeric
              v-model="registro.TARA_EXPEDICAO"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tara Trilho Exped Repesagem" label-for="tara-expedicao-repes">
            <vue-autonumeric
              v-model="registro.TARA_EXPEDICAO_REPES"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Tara Trilho Desossa" label-for="tara-caixaria">
            <vue-autonumeric
              v-model="registro.TARA_CAIXARIA"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tara Trilho Produção" label-for="tara-caixaria-tendal">
            <vue-autonumeric
              v-model="registro.TARA_CAIXARIA_TENDAL"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tara Quarteio" label-for="tara-quarteio">
            <vue-autonumeric
              v-model="registro.TARA_QUARTEIO"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Peso Máximo do Miúdo" label-for="peso-maximo-miudo">
            <vue-autonumeric
              v-model="registro.PESO_MAXIMO_MIUDO"
              :options="{ 
                digitGroupSeparator: '.', 
                decimalCharacter: ',', 
                decimalCharacterAlternative: '.', 
                roundingMethod: 'U', 
                minimumValue: '0', 
                decimalPlaces: 2
              }"
              :class="['form-control text-right']"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Limitador de Etiquetas - Máximo" label-for="abate-indice">
            <b-form-input
              v-model.number="registro.ABATE_INDICE"
              type="number"
              min="0"
              class="text-right"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tipo de Limitador de Etiquetas" label-for="op-limitador-etiquetas">
            <b-form-select v-model="registro.OP_LIMITADOR_ETIQUETAS">
              <option value="0">0 - Sem limite (GEN_NUMERO_CAIXA)</option>
              <option value="1">1 - Usar Limitador (ABATE_INDICE)</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
        <i class="fa fa-check-circle mr-1"></i> SALVAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import ClientePesquisa from '../views/pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../views/pesquisa/ProdutoPesquisa.vue'
import BensPesquisa from '../views/pesquisa/BensPesquisa.vue'
import CentroCustoDropDown from '../views/componentes/dropdown/CentroCustoDropDown.vue'
import FuncionarioDropdown from '../views/componentes/dropdown/FuncionarioDropdown.vue'
import CustoOperacionalDropDown from '../views/componentes/dropdown/CustoOperacionalDropDown.vue'
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'ModalConfiguracaoDesossaAbate',
  components: {
    ClientePesquisa,
    ProdutoPesquisa,
    BensPesquisa,
    CentroCustoDropDown,
    FuncionarioDropdown,
    CustoOperacionalDropDown,
    VueAutonumeric
  },
  data() {
    return {
      registro: {
        SEQUENCIA: 1,
        // Desossa / Abate
        COD_CLI_DESOSSA: null,
        CD_PRODUTO_BANDA_ABATE: null,
        ID_CENTRO_CUSTO_DESOSSA: null,
        ID_CONFERENTE_DESOSSA: null,
        CUSTO_OP_ABATE_ID: null,
        EMBALAGEM_DESOSSA_ID: null,
        OP_USAR_CLIENTE_UNICO_DESOSSA: '0',
        OP_EXIBIR_QUALIDADE_ABATE: '0',
        // IDs do Abate
        BOI_ID: null,
        VACA_ID: null,
        NOVILHO_ID: null,
        TOURO_ID: null,
        BUFALO_MACHO_ID: null,
        BUFALO_FEMEA_ID: null,
        BOI_INTEIRO_ID: null,
        BOI_CAPAO_ID: null,
        // Taras e Pesagens
        TARA_ABATE: 0,
        TARA_EXPEDICAO: 0,
        TARA_EXPEDICAO_REPES: 0,
        TARA_CAIXARIA: 0,
        TARA_CAIXARIA_TENDAL: 0,
        TARA_QUARTEIO: 0,
        PESO_MAXIMO_MIUDO: 0,
        ABATE_INDICE: 0,
        OP_LIMITADOR_ETIQUETAS: '0'
      }
    }
  },
  methods: {
    abrir() {
      this.$refs.modalDesossaAbate.show()
    },
    fechar() {
      this.$refs.modalDesossaAbate.hide()
    },
    async carregarDados() {
      try {
        const { data } = await this.$http.get('/api/protected/parametro/getDados')
        if (data && data.length > 0) {
          this.registro = {
            ...this.registro,
            ...data[0],
            // Garantir valores default para checkboxes
            OP_USAR_CLIENTE_UNICO_DESOSSA: data[0].OP_USAR_CLIENTE_UNICO_DESOSSA || '0',
            OP_EXIBIR_QUALIDADE_ABATE: data[0].OP_EXIBIR_QUALIDADE_ABATE || '0',
            // Garantir valores default para selects
            OP_LIMITADOR_ETIQUETAS: data[0].OP_LIMITADOR_ETIQUETAS || '0',
            // Garantir valores default para campos numéricos
            TARA_ABATE: data[0].TARA_ABATE || 0,
            TARA_EXPEDICAO: data[0].TARA_EXPEDICAO || 0,
            TARA_EXPEDICAO_REPES: data[0].TARA_EXPEDICAO_REPES || 0,
            TARA_CAIXARIA: data[0].TARA_CAIXARIA || 0,
            TARA_CAIXARIA_TENDAL: data[0].TARA_CAIXARIA_TENDAL || 0,
            TARA_QUARTEIO: data[0].TARA_QUARTEIO || 0,
            PESO_MAXIMO_MIUDO: data[0].PESO_MAXIMO_MIUDO || 0,
            ABATE_INDICE: data[0].ABATE_INDICE || 0
          }
        }
      } catch (err) {
        console.error('Erro ao carregar configurações:', err)
        this.$root.$bvToast.toast('Erro ao carregar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    async salvar() {
      try {
        const { data } = await this.$http.post('/api/protected/parametro/update', {
          registro: this.registro
        })
        
        this.$root.$bvToast.toast(data.mensagem || 'Configurações salvas com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })
        
        this.fechar()
      } catch (err) {
        console.error('Erro ao salvar configurações:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    onModalShown() {
      this.carregarDados()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoDesossaAbate.vue